import Lottie from 'lottie-react-web';

import { AnimationLoaderPurple } from 'utils/assets';
import { ReactComponent as UserIcon } from 'utils/assets/images/userIcon.svg';

import styles from './CropImageSkeleton.module.scss';

interface ICropImageSkeleton {
  isLoading?: boolean;
}

export const CropImageSkeleton = ({ isLoading }: ICropImageSkeleton) => {
  return (
    <div className={styles.skeleton}>
      <div data-testid='icon' className={styles.skeleton__icon}>
        <UserIcon />
      </div>
      {isLoading && (
        <div data-testid='loading' className={styles.skeleton__loader}>
          <Lottie
            speed={0.8}
            width={500}
            height={50}
            options={{
              animationData: AnimationLoaderPurple,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice',
                viewBoxOnly: false,
              },
            }}
          />
        </div>
      )}
    </div>
  );
};
